export default {
    data() {
        return {
            unlayer: null,
        };
    },

    methods: {
        async loadUnlayerScript() {
            if (window['unlayer']) {
                console.warn('[UnlayerEditor] Unlayer runtime already loaded');
                this.unlayer = window['unlayer'];
                return;
            }

            try {
                await new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.onload = resolve;
                    script.onerror = reject;

                    script.setAttribute('src', 'https://editor.unlayer.com/embed.js');
                    document.body.appendChild(script);
                });

                this.unlayer = window['unlayer'];
            } catch (error) {
                console.error('[UnlayerEditor] failed to load unlayer', error);
                throw new Error('remote_runtime_not_found');
            }
        },

        /**
         * Upload event handler
         *
         * @param {UnlayerFile} files
         * @param {Function} done
         */
        async onImageUpload(files, done) {
            try {
                const [file] = files.attachments;
                const { url } = await this.$services.publicAssets.uploadAsset(this.eid, file, file.name, progressEvent => {
                    const { loaded, total } = progressEvent;
                    const progress = Math.round((loaded / total) * 100);
                    done({ progress });
                });

                done({ progress: 100, url });
            } catch (error) {
                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('email_templates_editor.messages.not_uploaded').toString(),
                    type: 'error',
                });
                done({ error }) ;
            }
        },
    }
};
